import { Configuration, LogLevel } from '@azure/msal-browser'
import { getEnv } from './env'

const clientId = getEnv('VITE_AZURE_CLIENT_ID')
const tenantId = getEnv('VITE_AZURE_TENANT_ID')
const redirectUri = getEnv('VITE_AZURE_REDIRECT_URI') || window.location.origin
const apiScope = getEnv('VITE_AZURE_API_SCOPE')

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return

        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          case LogLevel.Info:
            if (import.meta.env.DEV) {
              console.info(message)
            }
            break
          case LogLevel.Verbose:
            if (import.meta.env.DEV) {
              console.debug(message)
            }
            break
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Verbose : LogLevel.Warning
    }
  }
}

// Scopes for requesting access token
export const loginRequest = {
  scopes: [apiScope]
}

// Scopes for silent token acquisition
export const tokenRequest = {
  scopes: [apiScope]
}

export const isAuthConfigured = (): boolean => {
  return !!(clientId && tenantId)
}
